import { z } from "zod/v4";

// ---------------------------------------------------------------------------
// Shopify's `productRecommendations` read. The rows resolve to the SAME
// normalized `AgenticLogicProduct` shape a product query returns (plus
// `collectionIds`, which only this read populates) — see ./product-page.
// ---------------------------------------------------------------------------

/**
 * Shopify's required recommendation strategy.
 *
 * `RELATED` uses Shopify's algorithmic ranking and needs no merchant setup.
 * `COMPLEMENTARY` reads ONLY the products a merchant curated per product in
 * the Shopify Search & Discovery app (the
 * `shopify--discovery--product_recommendation.complementary_products`
 * metafield, up to 10 per product) and has NO algorithmic fallback: an
 * uncurated seed resolves an EMPTY list rather than an algorithmic one. A
 * caller that treats the two as interchangeable ships a rule that recommends
 * nothing on a store that never set complementary products up.
 */
export const AgenticLogicRecommendationIntentList = [
  "RELATED",
  "COMPLEMENTARY",
] as const;
export const AgenticLogicRecommendationIntentSchema = z.enum(
  AgenticLogicRecommendationIntentList
);
export type AgenticLogicRecommendationIntent =
  (typeof AgenticLogicRecommendationIntentList)[number];
